"use client";
import { useState } from "react";
import Image from "next/image";
import { BuiltTabData } from "@/app/ai/enterprise-search/root";
import CommonTitle from "@/components/common/CommonTitle";
import CommonSubtitle from "@/components/common/CommonSubtitle";
import aiStarIcon from "@/assets/images/icons/star-ai-icon.svg";

const BuiltTabArea = ({ builtTabData }: { builtTabData: BuiltTabData[] }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const activeItem = builtTabData[activeIndex];

  return (
    <section>
      <div className="bg-gradient-to-b to-[#F4F4FD] from-[#ffffff] py-[60px] 2xl:py-20">
        <div className="container mx-auto px-4">
          <div className="mb-8 text-center">
            <CommonTitle
              as="h2"
              fontSizeClass="text-[24px] lg:text-[32px] mb-2"
              fontWeightClass="font-semibold"
            >
              Who <span className="bg-gradient-to-r from-[#781E8F] to-[#422CBB] bg-clip-text text-transparent">Kroolo</span> Is Built For
            </CommonTitle>
          </div>
          <div className="mx-auto mb-8 flex flex-wrap justify-center gap-2 lg:mb-10">
            {builtTabData.map((item, index) => {
              const isActive = index === activeIndex;
              return (
                <button
                  key={index}
                  type="button"
                  onClick={() => setActiveIndex(index)}
                  className={`rounded-lg border px-3 py-1.5 text-sm font-normal lg:px-4 lg:py-2 ${isActive
                    ? "border-[#202020] bg-gradient-to-r from-[#781E8F] to-[#422CBB] bg-clip-text text-transparent"
                    : "border-[#E0E0EA] bg-white text-[#4A4A4A] hover:border-[#C5C5D8]"
                    }`}
                >
                  {item.intro}
                </button>
              );
            })}
          </div>
          <div className="relative overflow-hidden rounded-3xl  p-4 sm:p-6 lg:p-8">
            {activeItem && (
              <div className="flex flex-col items-stretch gap-6 xl:flex-row xl:items-center xl:gap-8 xl:justify-between">
                <div className="w-full xl:w-1/2 xl:max-w-[520px]">
                  <CommonTitle
                    as="h3"
                    fontWeightClass="font-semibold"
                    color="#202020"
                    fontSizeClass="text-[20px] lg:text-[22px] mt-4"
                  >
                    <span className="bg-gradient-to-r from-[#781E8F] to-[#422CBB] bg-clip-text text-transparent">
                      {activeItem.title}
                    </span>
                  </CommonTitle>
                  <CommonSubtitle color="#202020" fontSizeWeight="mt-1">
                    {activeItem.description}
                  </CommonSubtitle>
                  <div className="mb-8 mt-2.5 space-y-4 lg:mt-4 xl:mb-[48px] xl:mt-5 xl:space-y-6">
                    {activeItem.featureList.map((feature, index) => (
                      <p key={index} className="text-[14px] text-[#202020] lg:text-[16px] flex items-start gap-3">
                        <Image
                          src={aiStarIcon}
                          alt="AI built-in feature"
                          width={20}
                          height={20}
                          className="inline-block h-5 w-5 mt-1"
                        />
                        {feature}
                      </p>
                    ))}
                  </div>
                </div>
                <div className="relative flex h-fit w-full flex-1 items-center justify-center overflow-hidden xl:h-[420px]">
                  <Image
                    src={activeItem.featureImg}
                    alt={activeItem.intro}
                    className="w-full object-cover"
                    priority
                    draggable={false}
                    quality={100}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BuiltTabArea;
